import React from "react";
import { useMutation } from "@apollo/react-hooks";
import { useSubscription } from "@apollo/client";
import { CloseOutlined } from "@ant-design/icons";
import { GET_ANNOUNCEMENT_SUBSCRIPTION } from "../../../Graphql/subscriptions";
import { UPDATE_ANNOUNCEMENT_READ } from "../../../Graphql/mutations";
import {
  Button,
  Col,
  Row,
  message
} from "antd";

export const Announcement = () => {
  const user_id = localStorage.getItem("user_id");
  const { data } = useSubscription(
    GET_ANNOUNCEMENT_SUBSCRIPTION,
    {
      variables: { user_id: user_id }
    }
  );

  const [
    UPDATE_ANNOUNCEMENT_READ_MUTATION,
    { loading: updateAnnouncementLoading },
  ] = useMutation(UPDATE_ANNOUNCEMENT_READ);

  const onReadAnnouncement = async () => {
    try {
      const result = await UPDATE_ANNOUNCEMENT_READ_MUTATION({
        variables: { user_id: user_id, announcement_id: data?.announcementData[0]?.announcementDetails?.announcement_id }
      });
      if (result?.data?.updateDetail?.announcement_id) {
        // message.success("Announcement has been read");
      } else {
        message.error("Something went wrong.");
      }
    } catch (error) {
      message.error("Something went wrong.");
    }
  }

  return (
    data?.announcementData?.length ?
      <Row className="note" justify="space-between" align="middle">
        <Col>
          <span>
            {
              data?.announcementData[0]?.announcementDetails?.announcement_message
            }
          </span>
        </Col>
        <Col>
          <Button type="text" icon={<CloseOutlined />} onClick={onReadAnnouncement} />
        </Col>
      </Row> : ""
  );
};


